import { reactive, ref } from 'vue';
import cConfirmationModal from './c-confirmation-modal.vue';


/**
 * Confirmation modal handling.
 * Can get called by this.$confirmation.showConfirmation() and resolves a Promise if it's confirmed.
 */
export default {
  install(app /* , options */) {
    app.component(cConfirmationModal.name, cConfirmationModal);

    const confirmation = ref();

    /**
     * Shows a confirmation modal.
     *
     * @param {Object} options - Instance options.
     * @param {String} options.title - The title for the modal.
     * @param {String} options.text - The text for the modal.
     * @param {String} options.htmlText - The htmlText for the modal.
     * @param {String} [options.confirmText] - The confirmation label for the modal.
     * @param {String} [options.cancelText] - The cancel label for the modal.
     * @param {String} [options.hasCancelButton=true] - Allows to hide the cancel button.
     * @param {String} [options.clickBackgroundToClose=true] - Allows to disable outside clicks to cancel the confirmation.
     * @param {Function} [options.successCallback=true] - Allows to set a callback for the success event. Receives resolve & reject from the success Promise.
     *
     * @returns {Promise}
     */
    const showConfirmation = (options) =>
      new Promise((resolve, reject) => {
        confirmation.value = { resolve, reject, options };
      })
        //  Makes sure we don't get a console error.
        .catch(() => {})
        .finally(() => {
          confirmation.value = null;
        });

    /**
     * Closes the confirmation.
     */
    const closeConfirmation = () => {
      confirmation.value.reject();
    };

    app.config.globalProperties.$confirmation = reactive({
      showConfirmation,
      closeConfirmation,
      confirmation,
    });
  },
};
